import React from "react";
import useInView from "../../../hooks/useInView";
import "./TarjetaDeServicioDigi.css";

interface ServiceItem {
  title: string;
  desc: string;
}

interface TarjetaDeServicioDigiProps {
  service: ServiceItem;
  delay?: number;
  animationClass?: string;
}

export default function TarjetaDeServicioDigi({ service, delay = 0, animationClass = "" }: TarjetaDeServicioDigiProps) {
  const [ref, inView] = useInView({ threshold: 0.3 });

  return (
    <div
      ref={ref}
      className={`service-card-digi animate-card${inView ? " visible" : ""} ${animationClass}`}
      style={{ transitionDelay: `${delay}s` } as React.CSSProperties}
    >
      <h3 className="service-digi-title">{service.title}</h3>
      <p className="service-digi-text">{service.desc}</p>
    </div>
  );
}
